enum ActionTypes {
    SET_CURRENT_PAGE = '[Global] Set current page',

    ADD_PRODUCT_TO_CART ='[Cart Item] Add product to cart',
    ADD_PRODUCT_TO_CART_COMPLETED ='[Cart Item] Add product to cart completed',
    REMOVE_PRODUCT_FROM_CART ='[Cart Item] Remove product from cart',
    CLEAR_CART = '[Cart Item] Clear cart',
    SET_CART_ITEM_COUNT = '[Cart Item] Set cart item count',
    SET_USER_AUTHENTICATED = 'SET_USER_AUTHENTICATED',
}
export default ActionTypes;